var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var buttonStyle = {
    background: "transparent",
    border: "none",
    color: "#6B7280",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    padding: "8px 0",
    position: "relative",
};
var activeButtonStyle = __assign(__assign({}, buttonStyle), { color: "#28272C" });
var indicatorStyle = {
    background: "#1451B4",
    borderRadius: 999,
    bottom: -1,
    height: 2,
    left: 0,
    position: "absolute",
    right: 0,
};
export var HomeTabButton = function (_a) {
    var active = _a.active, label = _a.label, onClick = _a.onClick;
    return (_jsxs("button", __assign({ "aria-pressed": active, onClick: onClick, style: active ? activeButtonStyle : buttonStyle, type: "button" }, { children: [label, active ? _jsx("span", { style: indicatorStyle }) : null] })));
};
